<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Test Reports">
        <br />
        <div class="row">
          <div class="col-md-6 form-group">
            Test Type
            <b-form-select v-model="type" @input="typeEmpty = false" required>
              <option value="daily_test">Daily Test</option>
              <option value="all_india_mock_test">All India Mock Test</option>
             <option value="on_going_test">Recruitment Drive Test</option>
             <option value="subscription_practice_test">Subscription Practice Test</option>
             <option value="subscription_mock_test">Subscription Mock Test</option>

            </b-form-select>
            <div v-if="typeEmpty" style="color: red">Test Type is required</div>
          </div>
          <div class="col-md-6 form-group" v-if="this.type=='subscription_practice_test' || this.type=='subscription_mock_test'">
            Subscription
           <b-form-select v-model="subscription" :select-size="10" @input="subscriptionEmpty = false,getSubTests()" @change="getSubscriptions()" required>
            <option
              v-for="(subscription, index) in subscriptions"
              :key="index"
              :value="subscription.id"
            >
              {{ subscription.name }}
            </option>
          </b-form-select>
           <div v-if="subscriptionEmpty" style="color: red">
            Subscription is required
          </div>
          </div>
          <div class="col-md-6 form-group" v-else>
            Date
            <b-form-datepicker
              v-model="date"
              @input="getTests()"
            ></b-form-datepicker>
            <!--  <div v-if="DateEmpty" style="color: red">
            Date is required
          </div>-->
          </div>
        </div>
        <b-table-simple
          responsive
          bordered
          striped
          table-class="table-vcenter"
          v-if="tests.length > 0"
        >
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center">Test Name</b-th>
              <b-th class="text-center">Test Type</b-th>
              <b-th class="text-center">No Of Questions</b-th>
              <b-th class="text-center">Negative Mark</b-th>
              <b-th class="text-center">Each Question Mark</b-th>
              <b-th class="text-center">Action</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(test, index) in tests" :key="index">
              <b-td class="text-center">
                {{ index + 1 }}
              </b-td>
              <b-td class="text-center"> {{ test.name }} </b-td>
              <b-td class="text-center" v-if="test.type == 'ongoing'">
                {{ test.mock_test.tests.test_type }}
              </b-td>
               <b-td class="text-center" v-else-if="test.testable_type == 'subscription_content'">
                {{ test.test_type }}
              </b-td>
              <b-td class="text-center" v-else>
                {{ test.tests.test_type }}
              </b-td>
               <b-td class="text-center" v-if="test.type == 'ongoing'">
                {{ test.mock_test.tests.no_of_questions }}
              </b-td>
               <b-td class="text-center" v-else-if="test.testable_type == 'subscription_content'">
                {{ test.no_of_questions }}
              </b-td>
              <b-td class="text-center" v-else>
                {{ test.tests.no_of_questions }}
              </b-td>
               <b-td class="text-center" v-if="test.type == 'ongoing'">
                {{ test.mock_test.tests.negative_mark }}
              </b-td>
               <b-td class="text-center" v-else-if="test.testable_type == 'subscription_content'">
                {{ test.negative_mark }}
              </b-td>
              <b-td class="text-center" v-else>
                {{ test.tests.negative_mark }}
              </b-td>
                <b-td class="text-center" v-if="test.type == 'ongoing'">
                {{ test.mock_test.tests.each_question_mark }}
              </b-td>
              <b-td class="text-center" v-else-if="test.testable_type == 'subscription_content'">
                {{ test.each_question_mark }}
              </b-td>
              <b-td class="text-center" v-else>
                {{ test.tests.each_question_mark }}
              </b-td>
              <b-td class="text-center" v-if="test.type == 'ongoing'">
                <b-btn-group>
                  <router-link
                    :to="{
                      name: 'All User Test Reports',
                      params: { id: test.mock_test.tests.id, date: date, type: 'on_going_test' },
                    }"
                  >
                    <b-button size="sm" variant="alt-primary">
                      <i class="fa fa-fw fa-eye"></i>
                    </b-button>
                  </router-link>
                </b-btn-group>
              </b-td>
               <b-td class="text-center" v-else-if="test.testable_type == 'subscription_content'">
                <b-btn-group>
                  <router-link
                    :to="{
                      name: 'All User Test Reports',
                      params: {id: test.id,type:'subscription'},
                    }"
                  >
                    <b-button size="sm" variant="alt-primary">
                      <i class="fa fa-fw fa-eye"></i>
                    </b-button>
                  </router-link>
                </b-btn-group>
              </b-td>
               <b-td class="text-center" v-else-if="test.type == 'subscription_mock_test'">
                <b-btn-group>
                  <router-link
                    :to="{
                      name: 'All User Test ReportsSub',
                      params: {id: test.tests.id,type:'subscription', method:'subscription_mock_test'},
                    }"
                  >
                    <b-button size="sm" variant="alt-primary">
                      <i class="fa fa-fw fa-eye"></i>
                    </b-button>
                  </router-link>
                </b-btn-group>
              </b-td>
            <!--  <b-td class="text-center" v-else-if="test.type == 'all_india_mock_test'">
                <b-btn-group>
                  <router-link
                    :to="{
                      name: 'All User Test Reports',
                      params: {id: test.tests.id},
                    }"
                  >
                    <b-button size="sm" variant="alt-primary">
                      <i class="fa fa-fw fa-eye"></i>
                    </b-button>
                  </router-link>
                </b-btn-group>
              </b-td> -->
               <b-td class="text-center" v-else>
                <b-btn-group>
                  <router-link
                    :to="{
                      name: 'All User Test Reports',
                      params: { id: test.tests.id,date: date, type: test.type},
                    }"
                  >
                    <b-button size="sm" variant="alt-primary">
                      <i class="fa fa-fw fa-eye"></i>
                    </b-button>
                  </router-link>
                </b-btn-group>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      tests: [],
      type: "",
      typeEmpty: false,
      date: "",
      subscriptions:[],
      subscription:"",
      subscriptionEmpty: false
    };
  },
  mounted(){
    this.getSubscriptions();
  },
  methods: {
     async getSubscriptions(){
      await axios
        .get(`${this.$store.getters.baseUrl}/get/subscriptions`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.subscriptions = response.data.subscriptions;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getSubTests() {

       if(this.type == "") {
        this.typeEmpty = true;
        return;
      }

       if(this.subscription == "") {
        this.subscriptionEmpty = true;
        return;
      }
       const formdata = new FormData();
      formdata.append("type", this.type);
      formdata.append("sub_id", this.subscription);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/sub-test-lists`,formdata,         {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            console.log(response.data)
            this.tests = response.data.tests;
             if (!this.tests.length > 0) {
              this.$swal({
                title: "Info",
                text: "No test found on given Subscription",
                icon: "warning",
              });
            }
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getTests() {
      if (this.type == "") {
        this.typeEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("type", this.type);
      formdata.append("date", this.date);
        console.log(this.type);
        console.log(this.date);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/all-test-lists
`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.tests = response.data.test_lists;
            if (!this.tests.length > 0) {
              this.$swal({
                title: "Info",
                text: "No test found on given date",
                icon: "warning",
              });
            }
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
